import { render, staticRenderFns } from "./Soporte.vue?vue&type=template&id=3d3334dc&scoped=true"
import script from "./Soporte.vue?vue&type=script&lang=js"
export * from "./Soporte.vue?vue&type=script&lang=js"
import style0 from "./Soporte.vue?vue&type=style&index=0&id=3d3334dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3334dc",
  null
  
)

export default component.exports